// extracted by mini-css-extract-plugin
export default {"container":"tQ-z","dimension":"uQ-z","dimensionLabels":"vQ-z"};